import { z } from 'zod';

/** Zod schema for ADR-008 localized labels: `{ tr, en, ... }` */
export const localizedStringSchema = z.record(z.string(), z.string()).refine(
    (value) => Object.values(value).some((text) => typeof text === 'string' && text.length > 0),
    { message: 'En az bir dil metni gerekli' },
);

/** Mongoose field definition for localized strings (Map of locale → text). */
export const localizedStringMongoose = {
    type: Map,
    of: String,
    default: undefined,
};

/**
 * Resolve user-facing text from a localized value (Map, plain object, or legacy string).
 * @param {Map|Record<string, string>|string|null|undefined} value
 * @param {string} [locale='tr']
 * @param {string} [fallbackLocale='en']
 */
export function resolveLocalized(value, locale = 'tr', fallbackLocale = 'en') {
    if (value == null) return '';
    if (typeof value === 'string') return value;

    if (value instanceof Map) {
        return (
            value.get(locale) ??
            value.get(fallbackLocale) ??
            value.values().next().value ??
            ''
        );
    }

    if (typeof value === 'object') {
        return value[locale] ?? value[fallbackLocale] ?? Object.values(value).find((v) => typeof v === 'string') ?? '';
    }

    return String(value);
}
